import React from 'react'

import Layout from './Layout'
import providesDeleteOrganizationMutation from '../dataSync/providesDeleteOrganizationMutation'

type DeleteTeamProps = {
  deleteOrganization: () => void
}

export default providesDeleteOrganizationMutation(function DeleteTeam({
  deleteOrganization,
}: DeleteTeamProps) {
  return <Layout deleteOrganization={deleteOrganization} />
})
